import React, { ReactNode, Suspense } from 'react'
import { FC } from 'react'
import { Navigate, Outlet, Route } from 'react-router'
import { getAccessToken } from '../../AccessToken'
import { useLocation } from 'react-router-dom'
import { Spinner } from '@ifca-ui/core'

export const AuthGuard = () => {
  const { pathname, search } = useLocation()
  const AccessToken = getAccessToken()

  if (AccessToken) {
    return (
      <Suspense fallback={<Spinner />}>
        <Outlet />
      </Suspense>
    )
  } else {
    return <Navigate to="/login" replace/>
  }

}
